const UrlName = '/modular/admin/v1'

export default API => ({
    // 获取定制化的参数
    getConfiguration(url) {
        return API({ url: `${UrlName}/configuration/${url}` });
    },
    // 新获取定制化的参数
    getNewConfiguration(url) {
        return API({ url: `${UrlName}/configurations/${url}` });
    },
})
 